import axios   from "axios";
// import Swal    from "sweetalert2";
import Toaster from "./toaster";


axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN' : document.querySelector('meta[name="csrf-token"]').getAttribute('content')
};


export default class AdfShare
{
    constructor ()
    {
        this.isSearchPage = document.querySelector('body').classList.contains('search-page');
        this.pageType = document.querySelector("body").attributes["data-page-id"].value;

        this.createClosure();
        this.bindEvents();
    }

    createClosure ()
    {
        this.fctShareClick = this.onShareClick.bind(this);
        this.fctOnDidCopyUrl = this.onDidCopyUrl.bind(this);
        this.fctOnDidShareUrl = this.onDidShareUrl.bind(this);
    }

    bindEvents ()
    {
        this.btnsShare = Array.from(document.querySelectorAll("[data-btn-share]"))
                              .forEach( btn => btn.addEventListener("click", this.fctShareClick));

        window.addEventListener("copy-resource-url", this.fctOnDidCopyUrl);
        window.addEventListener("share-resource", this.fctOnDidShareUrl);
    }

    onDidCopyUrl (e)
    {
        let message = e.detail.message;
        Toaster.fire(message)
    }

    onDidShareUrl (e)
    {
        if (e.detail.message)
        {
            Toaster.fire(e.detail.message);
        }
    }

    onShareClick ( event)
    {
        let btn = event.target;
        let button = btn.closest("button");

        let type = this.pageType

        if (window.__login__)
        {
            window.__login__.show("share-resource", {
                id:  button.attributes["data-share-id"].value,
                url: button.attributes["data-share-url"].value,
                type
            });

            //this.userDialog.showModal();
        }

    }

}
